"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Image", {
  enumerable: true,
  get: function () {
    return _Image.default;
  }
});
exports.MediaComponent = void 0;
Object.defineProperty(exports, "MediaDisclaimer", {
  enumerable: true,
  get: function () {
    return _MediaDisclaimer.MediaDisclaimer;
  }
});
Object.defineProperty(exports, "Video", {
  enumerable: true,
  get: function () {
    return _Video.default;
  }
});
exports.default = void 0;
var _analytics = require("../analytics");
var _breakpoints = require("../breakpoints");
var _Image = _interopRequireDefault(require("./Image"));
var _Video = _interopRequireDefault(require("./Video"));
var _jsxRuntime = require("react/jsx-runtime");
var _MediaDisclaimer = require("./MediaDisclaimer");
const MediaComponent = function (_ref) {
  let {
    interactiveVideo,
    ...props
  } = _ref;
  const currentBreakpoint = (0, _breakpoints.useBreakpointName)();
  const breakpoints = (interactiveVideo === null || interactiveVideo === void 0 ? void 0 : interactiveVideo.breakpoints) || ["mobile", "tablet", "desktop"];
  const hasInteractiveVideoInCurrentBreakpoint = interactiveVideo && breakpoints.indexOf(currentBreakpoint) >= 0;
  return hasInteractiveVideoInCurrentBreakpoint ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Video.default, {
    interactiveVideo: interactiveVideo,
    ...props
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.default, {
    ...props
  });
};
exports.MediaComponent = MediaComponent;
var _default = exports.default = (0, _analytics.withAnalytics)(MediaComponent)({});